import { ProfileSettingVisibility } from '@flipster/apis/v1/user/types';
import { V2OrderSideType } from '@flipster/utils/types/base';

export function visibilityToBoolean(visibility: ProfileSettingVisibility) {
  return {
    PUBLIC: true,
    PRIVATE: false,
  }[visibility];
}
export function booleanToVisibility(bool: boolean): ProfileSettingVisibility {
  return bool ? 'PUBLIC' : 'PRIVATE';
}

// context: https://prextech.slack.com/archives/C087CLN6AKD/p1739753532662939
export function capitalizedSideToOrderSide(side: Uppercase<V2OrderSideType>): V2OrderSideType {
  switch (side) {
    case 'LONG':
      return 'Long';
    case 'SHORT':
      return 'Short';
    default:
      side satisfies never;
      throw Error('unreachable');
  }
}
